import { FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { CustomersFormGroup } from '../interfaces/customer';

// The target FormGroup type really is supposed to be any.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CustomersFormGroupAdapters = FormAdapterBase<CustomersFormGroup, any>[];

export abstract class FormAdapterBase<
    T extends FormGroup | FormArray, // Input FormGroup or Array
    U extends T | AbstractControl, // Target FormGroup or Array
> {

    protected basePath: string = '';

    protected extraConfig: { [key: string]: string | number | boolean } = {};

    protected form: T;

    public constructor(form: T, basePath: string, extraConfig: { [key: string]: string | number | boolean } = {}) {
        this.form = form;
        this.basePath = basePath;
        this.extraConfig = extraConfig;
    }

    public abstract apply(): void;

    protected getForm(): T {
        return this.form;
    }

    protected getTargetForm(): U {
        if (this.basePath === '') {
            return this.form as U;
        }
        return this.form.get(this.basePath) as U;
    }
}
